class AgentDeployVersion {
    _item;
    _by;

    constructor(item, by) {
        this._item = item;
        this._by = by;
    }

    get raw() {
        return this._item;
    }

    /**
     * 국가별로 버전 배포시에 유효한 데이터를 가졋는지 검증합니다.
     */
    get _validByCountry() {
        console.log(this._item.countryCode)
        if (!this._item.countryCode) return false;
        return true;
    }

    /**
     * 국가별로 버전 배포시에 유효한 데이터를 가졋는지 검증합니다.
     */
    get _validByRentalcompany() {
        if (!this._item.rentalcompanyId) return false;
        return true;
    }

    /**
     * 버전을 배포합니다.
     *
     * 국가별로 배포하는지 또는 사업자별로 배포하는지에 따라 다른 로직을 수행합니다.
     */
    async deploy(PCVersion, DVVersion) {
        if (this._by === "country") {
            return await this._deployByCountry(PCVersion, DVVersion);
        } else if (this._by === "rentalcompany") {
            return await this._deployByRentalcompany(PCVersion, DVVersion);
        }

        throw new Error("You should define 'by' param at construct object to deploy agent versions");
    }

    /**
     * 국가별로 버전을 배포합니다.
     */
    async _deployByCountry(PCVersion, DVVersion) {
        /** 여기에 국가별 배포 로직을 구현합니다 */
        if (!this._validByCountry) return;

        // API CALL
        console.log("국가별 버전 배포: " + this.raw.countryCode);
    }

    /**
     * 임대사업자별로 버전을 배포합니다.
     */
    async _deployByRentalcompany(PCVersion, DVVersion) {
        /** 여기에 임대사업자별 배포 로직을 구현합니다 */
        if (!this._validByRentalcompany) return;

        // API CALL
        console.log("임대사업자별 버전 배포: " + this.raw.rentalcompanyId);
    }
}

export default AgentDeployVersion